export default __webpack_public_path__ + "static/media/p34.597ffefe.jpg";